<!--
  The CustomModal.vue is an example component that shows how to create a custom modal layout with slots and
  how to pass model data from a form to the modalAPI - listen to the ok event and emit it again with the data
  as the payload, this payload will be provided as the argument in the onOK function that is provided to the modalAPI
-->
<template>
    <Modal class="custom-modal" v-on="listeners" v-bind="$props" showHeaderSeparator>
        <div slot="modal-body" class="custom-modal-body">
            <div>Enter data to be logged on OK</div>
            <input v-model="data" />
        </div>
    </Modal>
</template>

<script>
import Modal from 'components/modals/Modal.vue';

export default {
    name: 'CustomModal',
    components: { Modal },
    props: Modal.props,
    data() {
        return {
            data: ''
        };
    },
    computed: {
        listeners() {
            // we bind the @ok listener to override it and emit an ok event with arguments (the component data)
            return { ...this.$listeners, ok: this.emitOk };
        }
    },
    methods: {
        emitOk() {
            this.$emit('ok', {
                data: this.data
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-modal ::v-deep .modal-container {
    width: 600px;
}

.custom-modal ::v-deep .modal-body {
    margin: 24px 16px 48px 16px;
    padding: 0;
}

.custom-modal ::v-deep .modal-header {
    padding-top: 6px;
}
</style>
